import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './importExport.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';
import importShipHero from '../../assets/import-ship-hero.png';
import importSideContainers from '../../assets/import-side-containers.png';
import importBottomPort from '../../assets/import-bottom-port.png';
import { sendContactEmail } from '../../utils/emailjs';

const ImportExport = () => {
  const navigate = useNavigate();
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    introduction: '',
  });

  const handleNavigateToInquiryForm = () => {
    navigate('/sell-your-business#kw-sell-inquiry');
  };

  useEffect(() => {
    const previousBackground = document.body.style.background;
    document.body.style.background = '#FFFFFF';
    document.body.classList.add('kw__page-hide-backtotop');

    return () => {
      document.body.style.background = previousBackground;
      document.body.classList.remove('kw__page-hide-backtotop');
    };
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewsletterForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'Import & Export Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      introduction: '',
    });
  };

  return (
    <div className="kw__import-page">
      <div className="kw__import-hero-bridge">
        <section className="kw__import-top kw__import-section">
          <p className="kw__import-outline">Import &amp; Export</p>

          <div className="kw__import-hero-copy">
            <h1>Connecting Markets, Facilitating Seamless Global Trade</h1>
            <p>
              Modern commerce thrives on the swift and secure movement of goods across borders. We manage a robust import and export portfolio,
              serving as a trusted gateway for global trade. By combining deep regulatory expertise, extensive distribution networks, and agile
              logistics management, we streamline cross-border supply chains&mdash;ensuring critical commodities and commercial goods reach their
              destinations efficiently and without friction.
            </p>
          </div>
        </section>

        <img src={importShipHero} alt="" className="kw__import-ship-hero" aria-hidden="true" />

        <section className="kw__import-black-band">
          <div className="kw__import-section kw__import-black-inner">
            <h2>
              Supply Chain Resilience Managed - Across
              <br />
              Dynamic Trade Routes
            </h2>
            <p>
              We master the complexities of international trade, where global regulations, customs frameworks, and shipping dynamics are constantly
              evolving. Managing port logistics, compliance documentation, and multimodal transport routes requires absolute operational discipline.
              Our structured risk-mitigation strategies ensure supply chain continuity, secure cargo handling, and optimized transit times even in
              unpredictable market conditions.
            </p>
          </div>
        </section>
      </div>

      <section className="kw__import-scale kw__import-section">
        <div className="kw__import-scale-copy">
          <h2>Scaling Global Reach through Strategic Trade Partnerships</h2>
          <p>
            International trade is about more than moving freight&mdash;it is about building long-term, high-trust networks that sustain international
            business growth. Our focus remains on expanding our global trade footprint while maintaining absolute operational stability. We ensure
            consistent inventory flow, strict international quality compliance, and reliable commercial execution across diverse product
            categories. This global trading platform is purpose-built for manufacturers, international suppliers, and investment partners who
            understand that sustainable trade growth depends on logistics infrastructure that remains reliable under continuous market pressure.
          </p>
        </div>

        <img src={importSideContainers} alt="" className="kw__import-side-image" aria-hidden="true" />
      </section>

      <section className="kw__import-cta">
        <div className="kw__import-section kw__import-cta-inner">
          <h2>Ready to Scale Your Global Supply Chain?</h2>
          <p>
            If you are looking to optimize your cross-border trade, partner on international distribution, or join a fast-growing global logistics
            network&mdash;partner with us and let&apos;s move markets together.
          </p>
          <button type="button" className="kw__import-cta-btn" onClick={handleNavigateToInquiryForm}>
            <span>Let&apos;s Connect to Discuss</span>
            <img src={buttonArrow} alt="" />
          </button>
        </div>
      </section>

      <section className="kw__import-bottom-image-wrap" aria-hidden="true">
        <img src={importBottomPort} alt="" className="kw__import-bottom-image" />
      </section>

      <section className="kw__import-newsletter kw__import-section">
        <div className="kw__import-news-copy">
          <p className="kw__import-news-label">Newsletter</p>
          <h3>Never Miss an Update</h3>
          <p>
            Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to
            your inbox.
          </p>
        </div>

        <form className="kw__import-news-form" onSubmit={handleSubmit}>
          <div className="kw__import-news-row">
            <input name="name" placeholder="Name" value={newsletterForm.name} onChange={handleChange} />
            <input name="email" placeholder="Email address" value={newsletterForm.email} onChange={handleChange} />
          </div>
          <textarea name="introduction" placeholder="Introduction" value={newsletterForm.introduction} onChange={handleChange} />
          <button type="submit" className="kw__import-news-submit">
            <span>Submit</span>
            <img src={buttonArrow} alt="" />
          </button>
        </form>
      </section>
    </div>
  );
};

export default ImportExport;
